import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumber } from '@app/shared/helpers/phone-formatter';

@Pipe({
    name: 'phoneNumber',
    standalone: false
})
export class PhoneNumberPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    return formatPhoneNumber(phoneNumber);
  }
}

